import { useMapGetter } from 'dashboard/composables/store.js';
import { buildPalette, hexToRgbTriplet } from 'shared/helpers/brandingPalette';

const applyPalette = (primaryHex, accentHex) => {
  if (typeof document === 'undefined') return;
  const root = document.documentElement;
  if (primaryHex) {
    const primaryPalette = buildPalette(primaryHex);
    root.style.setProperty('--brand-primary-rgb', hexToRgbTriplet(primaryHex));
    Object.entries(primaryPalette).forEach(([tone, hex]) => {
      root.style.setProperty(`--woot-${tone}`, hexToRgbTriplet(hex));
    });
  }
  if (accentHex) {
    const accentPalette = buildPalette(accentHex);
    root.style.setProperty('--brand-secondary-rgb', hexToRgbTriplet(accentHex));
    Object.entries(accentPalette).forEach(([tone, hex]) => {
      root.style.setProperty(`--brand-accent-${tone}`, hexToRgbTriplet(hex));
    });
  }
};

const fetchAndApplyBranding = async () => {
  try {
    const res = await fetch('/api/v2/branding', {
      headers: { Accept: 'application/json' },
    });
    if (!res.ok) return null;
    const data = await res.json();
    applyPalette(data.primary_color, data.accent_color);
    return data;
  } catch {
    return null;
  }
};

export function useBranding() {
  const globalConfig = useMapGetter('globalConfig/get');
  /**
   * Replaces "KALL-AI" (any casing) in text with the installation name from
   * global config
   * @param {string} text - The text to process
   * @returns {string} - Text with "KALL-AI" replaced by installation name
   */
  const replaceInstallationName = text => {
    if (!text) return text;
    const installationName = globalConfig.value?.installationName;
    if (!installationName) return text;

    return text.replace(/kall-?ai/gi, installationName);
  };

  return {
    replaceInstallationName,
    applyPalette,
    fetchAndApplyBranding,
  };
}
